<template>
  <div class="page">
    <div class="text-center">
      <img :src="require('@/assets/images/like.svg')" />
      <h4>¡Bien hecho!</h4>
      <p>
        La alerta fue almacenada exitosamente y recibida por el Sistema de Alertas Tempranas de
        Medellín, quien se encargará de su debida gestión.
      </p>
      <h6>
        <strong>Recuerda su número de radicado {{ radicado }}</strong>
      </h6>
      <p>
        Gracias por enviar su alerta
      </p>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'PaginaNombreDe',
  props: {
    radicado: String,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapMutations('alerta', ['setPageValidate']),
  },
};
</script>

<style scoped>
.page {
  padding: 25px 0px;
}
h4 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 17px;
  margin-top: 48px;
}
h6 {
  font-size: 18px;
  margin: 27px 0px 17px 0px;
  letter-spacing: 0px;
}
p {
  font-size: 16px
}
</style>
